import { render, staticRenderFns } from "./LicensesPage.vue?vue&type=template&id=034faafb&scoped=true&"
import script from "./LicensesPage.vue?vue&type=script&lang=js&"
export * from "./LicensesPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "034faafb",
  null
  
)

export default component.exports